import { COLORS } from 'helpers/globals'

const star = {
  fontSize: '3rem',
  color: COLORS.secondary,
  marginTop: '.5rem',
  marginLeft: '.5rem'
}

export default {
  container: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    padding: '.5rem',
    fontSize: '1.5rem',
    background: COLORS.primary,
    color: 'white'
  },
  backButton: {
    margin: '0 .4rem',
    fontSize: '1.3rem',
    verticalAlign: '-.1rem'
  },
  body: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem 2rem 2rem 2rem',
    overflow: 'auto',
    fontSize: '1.3rem'
  },
  row: {
    display: 'flex',
    marginBottom: '1rem',
    flex: '0 0 auto'
  },
  rowSelector: {
    display: 'flex',
    marginBottom: '1rem',
    flex: '0 0 auto',
    alignContent: 'center',
    justifyContent: 'space-between'
  },
  column: {
    flex: '1 0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  text: {
    flex: 1,
    color: 'black',
    fontWeight: '400',
    fontSize: '1.5rem',
    '& p': {
      marginBottom: 0
    }
  },
  imageWrapper: {
    width: '40vw',
    height: '10rem',
    textAlign: 'right'
  },
  image: {
    height: 'auto',
    width: 'auto',
    maxWidth: '100%',
    maxHeight: '100%'
  },
  aovButton: {
    background: COLORS.primary,
    color: 'white',
    fontSize: '1.8rem',
    fontWeight: '400',
    textAlign: 'center',
    padding: '.7rem 2.5rem',
    borderRadius: '1rem',
    marginBottom: '1rem'
  },
  favorited: {
    ...star,
    color: COLORS.gold
  },
  notFavorited: star,
  current: {
    fontSize: '3rem',
    marginLeft: '1rem',
    marginTop: '.5rem',
    color: COLORS.ok
  },
  table: {
    color: 'black',
    flex: '0 0 50%',
    width: 'inherit !important',
    marginBottom: '1rem',
    '& td': {
      padding: '.5rem 1rem .5rem .5rem !important',
      width: '50%',
      border: 'none'
    },
    '& > tbody > tr': {
      '&:nth-child(even)': {
        background: COLORS.tertiary
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/ModelSelector/CameraDetails/style.js